import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slide from '@material-ui/core/Slide';
import { filterChange,
    signaturesFilterChange,
    signaturesFilterHistoricChange,
    signaturesUserChange,
    toggleSwitch } from '../../actions/index.js';
import { FilterActions, ToggleActions } from '../../constants/constants.js';
import { _ } from '../../functions/translator.js';
import Icon from '@mdi/react';
import { mdiDelete } from '@mdi/js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';

function SignaturesFilterHistoric (props) {
    const {signaturesFilter, itemsSwitch, metrics, signaturesFilterHistoric, projectUsers, popUpMenu} = useSelector(state => ({
        signaturesFilter     : state.switches.signaturesFilter,
        itemsSwitch : state.switches.items,
        metrics            : state.switches.metrics,
        signaturesFilterHistoric : state.signaturesFilterHistoric,
        projectUsers : state.projectUsers,
        popUpMenu          : state.popUpMenu,
    }))

    const handleClose = () => {
        props.signaturesFilterHistoricChange([])
        props.toggleSwitch(ToggleActions.SIGNATURES_FILTER, false)
        //props.toggleSwitch(ToggleActions.MENU, true);
        props.filterChange(FilterActions.CARDS_GROUP_IDS, null);
        props.signaturesFilterChange([]);
        props.signaturesUserChange([]);
    }

    const handleMinimize = () => {
        props.toggleSwitch(ToggleActions.SIGNATURES_FILTER, false)
        //props.toggleSwitch(ToggleActions.MENU, true);
    }

    const metricsDropdownClass = 'metrics-dropdown'
    
    const render = signaturesFilter && !popUpMenu.show && !metrics;

    return (
        <Slide in={render} direction='left'>
            <div className={itemsSwitch ? 'no-height-items-switch' : 'no-height'}>
                <div className='w-100 d-flex justify-content-end'>
                    <div className={metricsDropdownClass}>
                        <InfoTooltip class={'float-left'} placement={'left'} message={'signatures filter message'}/>
                        <p className='text filter-title'>
                            { _(' Filtros de Firmas Aplicados') }
                            <button className='float-right' onClick={handleMinimize}></button>
                        </p>
                        {signaturesFilterHistoric.map((signature, index) => {
                            return (
                                <div key={index}>
                                    <p>{signature.signed ? 'Firmado por:' : 'Sin firmas de:'}</p>
                                    <ul>
                                        {signature.signaturesFilter.map((p, idx) => {
                                            if (typeof(p) === 'number'){
                                                const user = projectUsers[p];
                                                if (user) {
                                                    return (
                                                        <li className='m-0' key={idx}>
                                                            <p>{user.attributes.first_name} {user.attributes.last_name} {user.attributes.position && `- ${user.attributes.position}`}</p>
                                                        </li>
                                                    );
                                                }
                                            } else {
                                                return <li className='m-0' key={idx}><p>{p}</p></li>;
                                            }
                                        })}
                                    </ul>
                                </div>
                            );
                        })}
                        <div
                            className='w-100 d-flex justify-content-end d-inline-flex ml-2'
                            style={{
                                position: 'sticky',
                                bottom: '0',
                                right: '0',
                            }}
                        >
                            <Icon className='border rounded cursor-pointer' 
                            path={mdiDelete} 
                            size='30px' 
                            color='white' 
                            style={{backgroundColor: '#fc424a', margin:'5px', padding:'5px'}} 
                            onClick={handleClose} />
                        </div>
                    </div>
                </div>
            </div>
        </Slide>
    );
}


function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        signaturesFilterHistoricChange : signaturesFilterHistoricChange,
        filterChange : filterChange,
        signaturesUserChange: signaturesUserChange,
        signaturesFilterChange: signaturesFilterChange,
    }, dispatch)
}

export default connect(null, matchDispatchToProps)(SignaturesFilterHistoric);